import { theme } from '../../common/styles/theme';
import Icon from '../Icon';
import React from 'react';

const DEFAULT_WIDTH = 432;

type Type = 'info';

type Palette = {
  background: string;
  icon: Type;
};

const paletteMap: Record<Type, Palette> = {
  info: {
    background: theme.colors.flag.informative,
    icon: 'info',
  },
};

export interface CallOutProps {
  children: React.ReactNode;
  type: Type;
  width: string | number;
}

export const CallOut: React.FC<CallOutProps> = ({
  children,
  type,
  width = DEFAULT_WIDTH,
}: CallOutProps) => {
  const palette = paletteMap[type];

  return (
    <div
      style={{
        width,
        display: 'flex',
        gap: 12,
        backgroundColor: palette.background,
        padding: 12,
        borderRadius: 8,
        color: theme.colors.primary.black,
        fontSize: 14,
      }}
    >
      <div style={{}}>
        <Icon name={palette.icon} size="small-medium" />
      </div>

      <div>{children}</div>
    </div>
  );
};
